import { z } from 'zod'

export const paramsSchema = z.object({
  cottageUid: z.string(),
  bookmarkLists: z.array(z.number().int()),
  note: z.string().nullable().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>
